import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = {
  key: 0,
  class: "w-full"
}
const _hoisted_3 = { class: "text-blue-900 font-normal text-lg" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "w-full mt-1 text-gray-800 font-normal" }
const _hoisted_6 = { class: "mt-1 space-y-0.5 text-gray-800" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Asutuse nimi:", -1)
const _hoisted_8 = { class: "pl-1.5" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Kiirgustegevuse asukoht:", -1)
const _hoisted_10 = { class: "pl-1.5" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "font-medium" }, "Mõõtmise meetod:", -1)
const _hoisted_12 = { class: "pl-1.5" }
const _hoisted_13 = {
  key: 1,
  class: "w-full"
}
const _hoisted_14 = { class: "text-blue-900 font-normal text-lg" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isDetailView)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, " Kiirgustöötaja kutsekiirituse dooside aruanne " + _toDisplayString(_ctx.data.reportYear), 1),
          (_ctx.data.licenseNumber)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Kiirgustegevusloa nr: " + _toDisplayString(_ctx.data.licenseNumber), 1))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("div", _hoisted_5, [
            _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.data.userName), 513), [
              [_vShow, _ctx.data.userName]
            ]),
            _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.data.companyName), 513), [
              [_vShow, _ctx.data.companyName]
            ]),
            _withDirectives(_createElementVNode("div", null, _toDisplayString(_ctx.data.companyEmail), 513), [
              [_vShow, _ctx.data.companyEmail]
            ])
          ], 512), [
            [_vShow, _ctx.data.userName || _ctx.data.companyName || _ctx.data.companyEmail]
          ]),
          _withDirectives(_createElementVNode("div", { class: "w-full mt-4 text-blue-900 font-normal text-lg" }, _toDisplayString(_ctx.dateRangeTitle), 513), [
            [_vShow, _ctx.dateRangeTitle]
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_7,
              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.data.buildingName), 1)
            ], 512), [
              [_vShow, _ctx.data.buildingName]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_9,
              _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.data.Address), 1)
            ], 512), [
              [_vShow, _ctx.data.Address]
            ]),
            _withDirectives(_createElementVNode("div", null, [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.data.measurementMethod), 1)
            ], 512), [
              [_vShow, _ctx.data.measurementMethod]
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.detailViewTitle), 1)
        ]))
  ]))
}